<template>
  <app-toast class='resend-confirmation-toast' :message='message'>
    <div class='toast-body' v-html="$t('user.confirmation.resent', {mail: message.mail})">
    </div>
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'resend-confirmation',
    props: {
      message: Object
    },

    components: {
      'app-toast': appToast
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .delete-bank-toast {
    strong {
      color: map_get($palette-primary, main);
    }
  }
</style>
